// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"481":"3fef5864","784":"746097f4"}[chunkId] + ".chunk.css";
};